import { formatDate } from '../../utils/formatting';

interface DateHeaderProps {
  date: string;
}

export const DateHeader: React.FC<DateHeaderProps> = ({ date }) => (
  <div
    className="col-span-full flex items-center gap-4 py-2 text-sm font-medium text-gray-500"
  >
    <div className="h-px flex-1 bg-gray-200" />
    <span>{formatDate(date)}</span>
    <div className="h-px flex-1 bg-gray-200" />
  </div>
);